import { registerBeginnerPixelCustomColourExtension } from '../helpers/pixel-colour-extension.js';
import { registerBeginnerPixelLedBlocks } from './pixel-led-blocks.js';
import { registerBeginnerStandardAndRgbLedBlocks } from './standard-rgb-led-blocks.js';

let registered = false;

export function registerBeginnerLedBlocks(): void {
  if (registered) {
    return;
  }
  registerBeginnerPixelCustomColourExtension();
  registerBeginnerStandardAndRgbLedBlocks();
  registerBeginnerPixelLedBlocks();
  registered = true;
}

export { registerBeginnerPixelLedBlocks } from './pixel-led-blocks.js';
export { registerBeginnerStandardAndRgbLedBlocks } from './standard-rgb-led-blocks.js';
